export default __webpack_public_path__ + "static/media/zeroq.68d6fc6e.svg";